import { render, staticRenderFns } from "./FourPeopleBookingTag.vue?vue&type=template&id=2ccdbcf2&scoped=true"
import script from "./FourPeopleBookingTag.vue?vue&type=script&lang=js"
export * from "./FourPeopleBookingTag.vue?vue&type=script&lang=js"
import style0 from "./FourPeopleBookingTag.vue?vue&type=style&index=0&id=2ccdbcf2&prod&lang=less&scoped=true"
import style1 from "./FourPeopleBookingTag.vue?vue&type=style&index=1&id=2ccdbcf2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccdbcf2",
  null
  
)

export default component.exports